export const LOCALES = Object.freeze ({
  L18N_LOCALE_ENGLISH_US: 'en-us',
  L18N_LOCALE_GERMAN_DE: 'de-de',
  L18N_LOCALE_FRENCH_CA: 'fr-ca',
  L18N_LOCALE_SPANISH_ES: 'es-es',
  L18N_LOCALE_JAPANESE_JA: 'ja-ja',
  L18N_LOCALE_CHINESE_CN: 'zh-cn',
  L18N_LOCALE_PORTUGUESE_PT: 'pt-pt',
  L18N_LOCALE_PORTUGUESE_BR: 'pt-br',
  L18N_LOCALE_CHINESE_TW:'zh-tw',
  L18N_LOCALE_FRENCH_FR:'fr-fr',
  L18N_LOCALE_ENGLISH_CA:'en-ca',
  L18N_LOCALE_KOREA_KO:'kr-ko',
  L18N_LOCALE_CZECH_CZ:'cs-cz',
  L18N_LOCALE_ITALIAN_IT:'it-it',
  L18N_LOCALE_POLISH_PL:'pl-pl',
  L18N_LOCALE_RUSSIAN_RU:'ru-ru',
  L18N_LOCALE_THAI_TH:'th-th',
  L18N_LOCALE_VIETNAMESE_VN:'vi-vn',
  L18N_LOCALE_TURKISH_TR:'tr-tr',
  L18N_LOCALE_SPANISH_MX:'es-mx',
});

export const LOCALE_LABELS = Object.freeze({
  [LOCALES.L18N_LOCALE_CZECH_CZ]:'Češka',
  [LOCALES.L18N_LOCALE_CHINESE_CN]:'中国 - 中国',
  [LOCALES.L18N_LOCALE_CHINESE_TW]:'中國 - 台灣',
  [LOCALES.L18N_LOCALE_ENGLISH_CA]:'English - Canada',
  [LOCALES.L18N_LOCALE_ENGLISH_US]:'English - United States',
  [LOCALES.L18N_LOCALE_FRENCH_CA]:'Français - Canada',
  [LOCALES.L18N_LOCALE_FRENCH_FR]:'Français - France',
  [LOCALES.L18N_LOCALE_GERMAN_DE]:'Deutsch',
  [LOCALES.L18N_LOCALE_ITALIAN_IT]:'Italiano',
  [LOCALES.L18N_LOCALE_JAPANESE_JA]:'日本',
  [LOCALES.L18N_LOCALE_KOREA_KO]:'한국어',
  [LOCALES.L18N_LOCALE_POLISH_PL]:'Polski',
  [LOCALES.L18N_LOCALE_PORTUGUESE_BR]:'Português - Brasil',
  [LOCALES.L18N_LOCALE_PORTUGUESE_PT]:'Português - Portugal',
  [LOCALES.L18N_LOCALE_RUSSIAN_RU]:'русский',
  [LOCALES.L18N_LOCALE_SPANISH_MX]:'Español - America Latina',
  [LOCALES.L18N_LOCALE_SPANISH_ES]:'Español - España',
  [LOCALES.L18N_LOCALE_THAI_TH]:'ภาษาไทย',
  [LOCALES.L18N_LOCALE_TURKISH_TR]:'Türkçe',
  [LOCALES.L18N_LOCALE_VIETNAMESE_VN]:'Việt',

});

export const LOCALE_DEFAULT = LOCALES.L18N_LOCALE_ENGLISH_US;

export const KEYS = Object.freeze({
  L18N_KEY_LABEL_PARTNER_ROLE:'L18N_KEY_LABEL_PARTNER_ROLE',
  L18N_KEY_LABEL_INTEGRATOR:'L18N_KEY_LABEL_INTEGRATOR',
  L18N_KEY_LABEL_PROVIDER:'L18N_KEY_LABEL_PROVIDER',
  L18N_KEY_LABEL_PARTNER_LEVEL:'L18N_KEY_LABEL_PARTNER_LEVEL',
  L18N_KEY_LABEL_PARTNER_SPECIALIZATION:'L18N_KEY_LABEL_PARTNER_SPECIALIZATION',
  L18N_KEY_LABEL_CISCO_POWERED_SERVICE:'L18N_KEY_LABEL_CISCO_POWERED_SERVICE',
  L18N_KEY_LABEL_PARTNER_NAME:'L18N_KEY_LABEL_PARTNER_NAME',
  L18N_KEY_LABEL_LOCATION:'L18N_KEY_LABEL_LOCATION',
  L18N_KEY_LABEL_COUNTRY:'L18N_KEY_LABEL_COUNTRY',
  L18N_KEY_LABEL_PARTNER_NAME_KEYWORD:'L18N_KEY_LABEL_PARTNER_NAME_KEYWORD',
  L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_:'L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_',
  L18N_KEY_LABEL_SORTING:'L18N_KEY_LABEL_SORTING',
  L18N_KEY_LABEL_SPECIALIZATIONS:'L18N_KEY_LABEL_SPECIALIZATIONS',
  L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS:'L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS',
  L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES:'L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES',
  L18N_KEY_LABEL_GOLD_PROVIDER:'L18N_KEY_LABEL_GOLD_PROVIDER',
  L18N_KEY_LABEL_PREMIER_PROVIDER:'L18N_KEY_LABEL_PREMIER_PROVIDER',
  L18N_KEY_LABEL_SELECT_PROVIDER:'L18N_KEY_LABEL_SELECT_PROVIDER',
  L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE:'L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE',
  L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE:'L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE',
  L18N_KEY_LABEL_OPEN:'L18N_KEY_LABEL_OPEN',
  L18N_KEY_LABEL_EXPAND:'L18N_KEY_LABEL_EXPAND',
  L18N_KEY_LABEL_COLLAPSE:'L18N_KEY_LABEL_COLLAPSE',
  L18N_KEY_LABEL_CHOOSE_A_COUNTRY:'L18N_KEY_LABEL_CHOOSE_A_COUNTRY',
  L18N_KEY_LABEL_CHOOSE_A_ROLE:'L18N_KEY_LABEL_CHOOSE_A_ROLE',
  L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_:'L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_',
  L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_:'L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_',
  L18N_KEY_LABEL_CHOOSE_EXPERTISE_S:'L18N_KEY_LABEL_CHOOSE_EXPERTISE_S',
  L18N_KEY_LABEL_CHOOSE_LEVEL_S_:'L18N_KEY_LABEL_CHOOSE_LEVEL_S_',
  //L18N_KEY_LABEL_PARTNER_SPECIALIZATION:'L18N_KEY_LABEL_PARTNER_SPECIALIZATION',
  //L18N_KEY_LABEL_CISCO_POWERED_SERVICE:'L18N_KEY_LABEL_CISCO_POWERED_SERVICE',
  L18N_KEY_LABEL_PARTNER_COUNTRY:'L18N_KEY_LABEL_PARTNER_COUNTRY',
  L18N_KEY_LABEL_INTEGRATOR_LEVELS:'L18N_KEY_LABEL_INTEGRATOR_LEVELS',
  L18N_KEY_LABEL_PROVIDER_LEVELS:'L18N_KEY_LABEL_PROVIDER_LEVELS',
  L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS:'L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS',
  L18N_KEY_LABEL_CISCO_POWERED_SERVICES:'L18N_KEY_LABEL_CISCO_POWERED_SERVICES',
  L18N_KEY_LABEL_PARTNER_NAMES:'L18N_KEY_LABEL_PARTNER_NAMES',
  //L18N_KEY_LABEL_PARTNER_NAME_KEYWORD:'L18N_KEY_LABEL_PARTNER_NAME_KEYWORD',
  //L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_:'L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_',
  L18N_KEY_LABEL_BACK:'L18N_KEY_LABEL_BACK',
  L18N_KEY_LABEL_ALL_RESULTS:'L18N_KEY_LABEL_ALL_RESULTS',
  L18N_KEY_LABEL_ALL:'L18N_KEY_LABEL_ALL',
  L18N_KEY_LABEL_SAVED:'L18N_KEY_LABEL_SAVED',
  L18N_KEY_LABEL_MY_PARTNERS:'L18N_KEY_LABEL_MY_PARTNERS',
  L18N_KEY_LABEL_ADD:'L18N_KEY_LABEL_ADD',
  L18N_KEY_LABEL_REMOVE:'L18N_KEY_LABEL_REMOVE',
  L18N_KEY_LABEL_ADD_TO_COMPARE:'L18N_KEY_LABEL_ADD_TO_COMPARE',
  L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE:'L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE',
  L18N_KEY_LABEL_COMPARE_SELECTED:'L18N_KEY_LABEL_COMPARE_SELECTED',
  L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR:'L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR',
  L18N_KEY_LABEL_COMPARE:'L18N_KEY_LABEL_COMPARE',
  //L18N_KEY_LABEL_PARTNER_LEVEL:'L18N_KEY_LABEL_PARTNER_LEVEL',
  //L18N_KEY_LABEL_PARTNER_NAME:'L18N_KEY_LABEL_PARTNER_NAME',
  L18N_KEY_LABEL_PROCESSING_IN_PROGRESS:'L18N_KEY_LABEL_PROCESSING_IN_PROGRESS',
  L18N_KEY_LABEL_RESULT:'L18N_KEY_LABEL_RESULT',
  L18N_KEY_LABEL_RESULTS:'L18N_KEY_LABEL_RESULTS',
  L18N_KEY_LABEL_NO_RESULTS:'L18N_KEY_LABEL_NO_RESULTS',
  L18N_KEY_LABEL_RESULT_IN:'L18N_KEY_LABEL_RESULT_IN',
  L18N_KEY_LABEL_RESULTS_IN:'L18N_KEY_LABEL_RESULTS_IN',
  L18N_KEY_LABEL_NO_RESULTS_IN:'L18N_KEY_LABEL_NO_RESULTS_IN',
  L18N_KEY_LABEL_PREVIOUS:'L18N_KEY_LABEL_PREVIOUS',
  L18N_KEY_LABEL_PREV:'L18N_KEY_LABEL_PREV',
  L18N_KEY_LABEL_NEXT:'L18N_KEY_LABEL_NEXT',
  L18N_KEY_LABEL_SAVE:'L18N_KEY_LABEL_SAVE',
  L18N_KEY_LABEL_EXPERTISE:'L18N_KEY_LABEL_EXPERTISE',
  L18N_KEY_LABEL_OVERVIEW:'L18N_KEY_LABEL_OVERVIEW',
  L18N_KEY_LABEL_IS_A_CISCO:'L18N_KEY_LABEL_IS_A_CISCO',
  L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION:'L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION',
  L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION:'L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION',
  //L18N_KEY_LABEL_SPECIALIZATIONS:'L18N_KEY_LABEL_SPECIALIZATIONS',
  L18N_KEY_LABEL_PAST_SEARCHES:'L18N_KEY_LABEL_PAST_SEARCHES',
  L18N_KEY_LABEL_PAST_SEARCH:'L18N_KEY_LABEL_PAST_SEARCH',
  L18N_KEY_LABEL_ROLES:'L18N_KEY_LABEL_ROLES',
  L18N_KEY_LABEL_TECHNOLOGY:'L18N_KEY_LABEL_TECHNOLOGY',
  L18N_KEY_LABEL_INDUSTRIES:'L18N_KEY_LABEL_INDUSTRIES',
  //L18N_KEY_LABEL_INTEGRATOR:'L18N_KEY_LABEL_INTEGRATOR',
  L18N_KEY_LABEL_INTEGRATORS:'L18N_KEY_LABEL_INTEGRATORS',
  //L18N_KEY_LABEL_PROVIDER:'L18N_KEY_LABEL_PROVIDER',
  L18N_KEY_LABEL_PROVIDERS:'L18N_KEY_LABEL_PROVIDERS',
  L18N_KEY_LABEL_OTHER:'L18N_KEY_LABEL_OTHER',
  L18N_KEY_LABEL_OTHERS:'L18N_KEY_LABEL_OTHERS',
  L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS:'L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS',
  L18N_KEY_LABEL_NO_SAVED_INTEGRATORS:'L18N_KEY_LABEL_NO_SAVED_INTEGRATORS',
  L18N_KEY_LABEL_NO_SAVED_PROVIDERS:'L18N_KEY_LABEL_NO_SAVED_PROVIDERS',
  L18N_KEY_LABEL_FILTER_BY_NEED:'L18N_KEY_LABEL_FILTER_BY_NEED',
  L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA:'L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA',
  L18N_KEY_LABEL_SEARCH_BY_LOCATION:'L18N_KEY_LABEL_SEARCH_BY_LOCATION',
  L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE:'L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE',
  L18N_KEY_LABEL_THERE_ARE:'L18N_KEY_LABEL_THERE_ARE',
  L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE:'L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE',
  L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING:'L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING',
  L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN:'L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN',
  L18N_KEY_LABEL_PARTNERS_SERVING_IN:'L18N_KEY_LABEL_PARTNERS_SERVING_IN',
  L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN:'L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN',
  L18N_KEY_LABEL_CHANGE_LOCATION:'L18N_KEY_LABEL_CHANGE_LOCATION',
  //L18N_KEY_LABEL_FILTER_BY_NEED:'L18N_KEY_LABEL_FILTER_BY_NEED',
  L18N_KEY_LABEL_SEARCH:'L18N_KEY_LABEL_SEARCH',
  L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE:'L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE',
  L18N_KEY_LABEL_SELECTED:'L18N_KEY_LABEL_SELECTED',
  L18N_KEY_LABEL_NO_MATCHES_FOUND:'L18N_KEY_LABEL_NO_MATCHES_FOUND',
  L18N_KEY_LABEL_RANK_UP:'L18N_KEY_LABEL_RANK_UP',
  L18N_KEY_LABEL_RANK_DOWN:'L18N_KEY_LABEL_RANK_DOWN',
  L18N_KEY_LABEL_NAME_UP:'L18N_KEY_LABEL_NAME_UP',
  L18N_KEY_LABEL_NAME_DOWN:'L18N_KEY_LABEL_NAME_DOWN',
  L18N_KEY_LABEL_LOGIN_REQUIRED:'L18N_KEY_LABEL_LOGIN_REQUIRED',
  L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION:'L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION',
  L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED:'L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED',
  L18N_KEY_LABEL_LOG_IN:'L18N_KEY_LABEL_LOG_IN',
  L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED:'L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED',
  L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED:'L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED',
  L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED:'L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED',
  L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED:'L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED',
  L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE:'L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE',
  L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION:'L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION',
  L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION:'L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION',
  L18N_KEY_LABEL_DIVERSE_PARTNER:'L18N_KEY_LABEL_DIVERSE_PARTNER',
  L18N_KEY_LABEL_ALPHABETICAL:'L18N_KEY_LABEL_ALPHABETICAL',
  L18N_KEY_LABEL_MOST_EXPERTISE:'L18N_KEY_LABEL_MOST_EXPERTISE',
  L18N_KEY_LABEL_DEVELOPER:'L18N_KEY_LABEL_DEVELOPER',
  L18N_KEY_LABEL_ADVISOR:'L18N_KEY_LABEL_ADVISOR',

  L18N_KEY_LABEL_FILTERS:'L18N_KEY_LABEL_FILTERS',
  L18N_KEY_LABEL_FILTER_VERB:'L18N_KEY_LABEL_FILTER_VERB',
  L18N_KEY_LABEL_PARTNER_EXPERTISE: 'L18N_KEY_LABEL_PARTNER_EXPERTISE',
  L18N_KEY_LABEL_DISMISS_VERB: 'L18N_KEY_LABEL_DISMISS_VERB',
  L18N_KEY_LABEL_SPECIALIZATION: 'L18N_KEY_LABEL_SPECIALIZATION',
  L18N_KEY_LABEL_EXPERTISES: 'L18N_KEY_LABEL_EXPERTISES',
  L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT: 'L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT',
  L18N_KEY_LABEL_ABOUT: 'L18N_KEY_LABEL_ABOUT',
  L18N_KEY_LABEL_CLEAR_COMPARATOR: 'L18N_KEY_LABEL_CLEAR_COMPARED_PARTNERS',
  L18N_KEY_LABEL_PARTNER_COMPARISON: 'L18N_KEY_LABEL_PARTNER_COMPARISON',
  L18N_KEY_LABEL_ROLE: 'L18N_KEY_LABEL_ROLE',
  L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS: 'L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS',
  L18N_KEY_LABEL_DESCRIPTION: 'L18N_KEY_LABEL_DESCRIPTION',
  L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION:'L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION',
  L18N_KEY_LABEL_LOG_OUT: 'L18N_KEY_LABEL_LOG_OUT',
  L18N_KEY_LABEL_INCLUSIVE_PARTNER: 'L18N_KEY_LABEL_INCLUSIVE_PARTNER',


  L18N_KEY_LABEL_ABOUT_CISCO: 'L18N_KEY_LABEL_ABOUT_CISCO',
  L18N_KEY_LABEL_CONTACT_US: 'L18N_KEY_LABEL_CONTACT_US',
  L18N_KEY_LABEL_CAREERS: 'L18N_KEY_LABEL_CAREERS',
  L18N_KEY_LABEL_MEET_OUR_PARTNERS: 'L18N_KEY_LABEL_MEET_OUR_PARTNERS',

  L18N_KEY_LABEL_FEEDBACK: 'L18N_KEY_LABEL_FEEDBACK',
  L18N_KEY_LABEL_HELP: 'L18N_KEY_LABEL_HELP',
  L18N_KEY_LABEL_TERMS_AND_CONDITIONS: 'L18N_KEY_LABEL_TERMS_AND_CONDITIONS',
  L18N_KEY_LABEL_PRIVACY_STATEMENT: 'L18N_KEY_LABEL_PRIVACY_STATEMENT',
  L18N_KEY_LABEL_COOKIES: 'L18N_KEY_LABEL_COOKIES',
  L18N_KEY_LABEL_TRADEMARKS: 'L18N_KEY_LABEL_TRADEMARKS',
  L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY: 'L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY',
  L18N_KEY_LABEL_SITEMAP: 'L18N_KEY_LABEL_SITEMAP',

  L18N_KEY_LABEL_HOW_TO_BUY: 'L18N_KEY_LABEL_HOW_TO_BUY',
  L18N_KEY_LABEL_PARTNERS: 'L18N_KEY_LABEL_PARTNERS',

  L18N_KEY_LABEL_PRODUCTS_AND_SERVICES: 'L18N_KEY_LABEL_PRODUCTS_AND_SERVICES',
  L18N_KEY_LABEL_SOLUTIONS: 'L18N_KEY_LABEL_SOLUTIONS',
  L18N_KEY_LABEL_SUPPORT: 'L18N_KEY_LABEL_SUPPORT',
  L18N_KEY_LABEL_LEARN: 'L18N_KEY_LABEL_LEARN',

  L18N_KEY_LABEL_EXPLORE_CISCO: 'L18N_KEY_LABEL_EXPLORE_CISCO',

  L18N_KEY_LABEL_MENU: 'L18N_KEY_LABEL_MENU',
  L18N_KEY_LABEL_CLOSE: 'L18N_KEY_LABEL_CLOSE',

  L18N_KEY_LABEL_SEE_MORE: 'L18N_KEY_LABEL_SEE_MORE',
  L18N_KEY_LABEL_SEE_LESS: 'L18N_KEY_LABEL_SEE_LESS',

  L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT: 'L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT',
  L18N_KEY_LABEL_SIGN_UP: 'L18N_KEY_LABEL_SIGN_UP',
});

